import { connect } from 'react-redux';
import { getSelectedProductionDivisionIdSelector } from 'redux-core/overview/selectors';

const mapStateToProps = (state) => ({
  divisionId: getSelectedProductionDivisionIdSelector(state),
});

export default connect(mapStateToProps);
